import { render, staticRenderFns } from "./Backend.vue?vue&type=template&id=c4a8ce9c&scoped=true&"
import script from "./Backend.vue?vue&type=script&lang=js&"
export * from "./Backend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a8ce9c",
  null
  
)

export default component.exports